import * as React from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { useIsMobile } from '../../mediaQueriesHelpers';
import { RootState } from '../../reducers/reducers';
import routes from '../../routes';
import { selectIsBuildDistroEnabled } from '../../selectors/selectors';
import { AppComponentProps, AppRouteComponentMatchParams } from '../../typescriptHelpers';
import { ErrorBoundaryHOC } from '../ErrorBoundary';
import { ValidatedAppRouteWrapper, ValidatedBucketRoute } from '../ValidatedRouteComponents';
import { AppBuilds } from './AppBuilds';
import { BuildBucketDetails, SharedBuildsDetails } from './BuildBucketDetails';
import { OptInScreen } from './OptInScreen';
import { useTrackPageView } from '@/helpers/trackingHelpers';

export const AppBuildsContainer: React.FC<AppComponentProps> = ErrorBoundaryHOC((props) => {
    const { appId } = props;

    const isMobile = useIsMobile();

    const isBuildDistroEnabled = useSelector((state: RootState) => selectIsBuildDistroEnabled(state, appId));

    if (!isBuildDistroEnabled) {
        return <OptInScreen {...props} />;
    }

    return (
        <Switch>
            {!isMobile && <ValidatedBucketRoute path={routes.appBucket} component={BuildBucketDetails} />}
            <Route
                path={isMobile ? [routes.appBuilds, routes.appBucket] : routes.appBuilds}
                render={(routeProps: RouteComponentProps) => {
                    const appRouteProps = routeProps as RouteComponentProps<AppRouteComponentMatchParams>;

                    return (
                        <ValidatedAppRouteWrapper {...appRouteProps}>
                            {(validatedAppComponentProps) => <AppBuilds {...validatedAppComponentProps} />}
                        </ValidatedAppRouteWrapper>
                    );
                }}
            />
        </Switch>
    );
});

export const SharedWithMeBuildsContainer: React.FC<AppComponentProps> = ErrorBoundaryHOC((props) => {
    const { appId } = props;

    const isBuildDistroEnabled = useSelector((state: RootState) => selectIsBuildDistroEnabled(state, appId));

    if (!isBuildDistroEnabled) {
        return <OptInScreen {...props} />;
    }

    useTrackPageView('Shared with me', [appId]);

    return (
        <Switch>
            <Route
                path={routes.sharedWithMeBucket}
                render={(routeProps: RouteComponentProps) => {
                    const appRouteProps = routeProps as RouteComponentProps<AppRouteComponentMatchParams>;

                    return (
                        <ValidatedAppRouteWrapper {...appRouteProps}>
                            {(validatedAppComponentProps) => <SharedBuildsDetails {...validatedAppComponentProps} />}
                        </ValidatedAppRouteWrapper>
                    );
                }}
            />
        </Switch>
    );
});
